import { useRuntimeTranslation } from "../../../hooks/useLoadI18nNamespaces";
import { HOME_LOCALIZATION_NAMESPACES } from "../../../methods/getRouteLocalizationNamespaces";

export const useHomepageV2Translation = () => useRuntimeTranslation(HOME_LOCALIZATION_NAMESPACES);

export default useHomepageV2Translation;
